import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { CarouselWithNavigation } from "../Carousel/components/CarouselWithNavigation";
import { usePreviewStoriesTabNavigation } from "../../hooks/usePreviewStoriesTabNavigation";
import { StoryPreview } from "./StoryPreview";
import { StoryDetailsModal } from "./StoryDetailsModal";
import { getViewedStories } from "./utils";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var SLIDER_SETTINGS = {
  navigation: false,
  spaceBetween: 16,
  centerInsufficientSlides: true,
  breakpoints: {
    767: {
      spaceBetween: 28
    }
  }
};
var StoriesV2 = function StoriesV2(_ref) {
  var storySliderSettings = _ref.storySliderSettings,
    detailSliderSettings = _ref.detailSliderSettings,
    list = _ref.list,
    onClose = _ref.onClose,
    onPreviewClick = _ref.onPreviewClick,
    onDetailClick = _ref.onDetailClick,
    onStoryView = _ref.onStoryView,
    _onInit = _ref.onInit,
    _onSlideChange = _ref.onSlideChange,
    previewNextBtnClassname = _ref.previewNextBtnClassname,
    previewPrevBtnClassname = _ref.previewPrevBtnClassname,
    storyIndex = _ref.storyIndex,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? true : _ref$lazy,
    _ref$showPreview = _ref.showPreview,
    showPreview = _ref$showPreview === void 0 ? true : _ref$showPreview,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;
  var _useState = useState(storyIndex),
    _useState2 = _slicedToArray(_useState, 2),
    detailStoryIndex = _useState2[0],
    setDetailStoryIndex = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    storiesList = _useState4[0],
    setStoriesList = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    detailList = _useState6[0],
    setDetailList = _useState6[1];
  var _usePreviewStoriesTab = usePreviewStoriesTabNavigation(),
    setPreviewSwiper = _usePreviewStoriesTab.setPreviewSwiper,
    hideBulletsForTabNav = _usePreviewStoriesTab.hideBulletsForTabNav;
  useEffect(function () {
    var viewedStories = getViewedStories();
    var previewItems = list.map(function (listItem) {
      // eslint-disable-next-line no-unused-vars
      var rest = _extends({}, (_objectDestructuringEmpty(listItem), listItem));
      if (viewedStories && !rest.viewed) {
        return _objectSpread(_objectSpread({}, rest), {}, {
          viewed: viewedStories[rest.id]
        });
      }
      return rest;
    });
    setStoriesList(previewItems);
  }, [list, setStoriesList, setDetailList]);
  var handleDetailList = function handleDetailList(story, i) {
    if (JSON.stringify(story.slides) !== JSON.stringify(detailList)) {
      setDetailList(story.slides);
    }
    setDetailStoryIndex(i);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StoryDetailsModal, {
    detailSliderSettings: detailSliderSettings,
    detailStoryIndex: detailStoryIndex,
    isOpen: isOpen,
    onClose: onClose,
    onDetailClick: onDetailClick,
    onStoryView: onStoryView,
    setDetailStoryIndex: setDetailStoryIndex,
    setStoriesList: setStoriesList,
    storiesList: storiesList,
    "data-t-id": "components-StoriesV2"
  }), showPreview && /*#__PURE__*/React.createElement("div", {
    className: cn('stories-preview')
  }, /*#__PURE__*/React.createElement(CarouselWithNavigation, {
    btnClassname: cn('button'),
    nextBtnClassname: previewNextBtnClassname,
    paginatePadding: false,
    prevBtnClassname: previewPrevBtnClassname,
    settings: _objectSpread(_objectSpread({}, SLIDER_SETTINGS), {}, {
      slidesPerView: 'auto',
      pagination: {
        clickable: true
      },
      watchSlidesProgress: true,
      onInit: function onInit(swiperInstance) {
        if (_onInit) {
          _onInit(swiperInstance);
        }
      },
      onSwiper: function onSwiper(swiperInstance) {
        setPreviewSwiper(swiperInstance);
      },
      onSlideChange: function onSlideChange(swiperInstance) {
        if (_onSlideChange) {
          _onSlideChange(swiperInstance);
        }
        hideBulletsForTabNav();
      }
    }, storySliderSettings)
  }, storiesList.map(function (story, i) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "".concat(story.image, "-").concat(story.text)
    }, /*#__PURE__*/React.createElement(StoryPreview, _extends({}, story, {
      lazy: lazy,
      onClick: function onClick(event) {
        onPreviewClick === null || onPreviewClick === void 0 ? void 0 : onPreviewClick(event, storiesList[i]);
        handleDetailList(story, i);
      }
    })));
  }))));
};
export { StoriesV2, StoryDetailsModal };